/**
 * Every tunable of the game layer. Drill tiers were set against measured runs on the ring
 * (see docs/superpowers/plans/2026-09-28-plan-4-drills-coach.md).
 */
export const DRILL_CONFIG = {
  throttle: {
    timeLimit: 15,        // s from the first throttle to the gate
    laneMargin: 0.5,      // m outside the cone lane before it counts as leaving
    startThrottle: 0.02,  // throttle that starts the clock
    wheelieMinSpeed: 1,   // m/s; below this a lifted front is not a wheelie
    tiers: {
      // maxSpin: s of wheelspin (src/sim/grip.ts, the same the HUD and the coach call wheelspin).
      3: { maxSpin: 0, maxWheelie: 0.05, maxTime: 6.5 },
      2: { maxSpin: 0.3, maxWheelie: 0.1, maxTime: 8 },
    },
  },
  brake: {
    timeLimit: 30,
    laneMargin: 0.5,
    minSpeed: 38 / 3.6,   // m/s the rider must reach before the stop counts
    brakeOn: 0.05,        // brake input that starts the braking phase
    stopSpeed: 0.2,       // m/s counted as stopped
    lockMaxStars: 1,      // a locked front caps the result
    tiers: { 3: { maxDistance: 0.5 }, 2: { maxDistance: 1.5 }, 1: { maxDistance: 4 } },
  },
  figure8: {
    timeLimit: 120,
    lobes: 4,             // two figure eights = four loops round the cones
    enterSide: 1.5,       // m past the crossing before a lobe starts (hysteresis)
    minWinding: 1.5 * Math.PI, // rad round the cone for the lobe to count as going round it
    turnYaw: 0.6,         // rad/s above this the bike is turning
    straightYaw: 0.3,     // rad/s below this the bike is on a straight
    areaRadius: 30,       // m from the crossing
    stanceGrace: 0.5,     // s of wrong stance before the rider is told
    tiers: {
      3: { maxMissed: 0, minStance: 0.85 },
      2: { maxMissed: 1, minStance: 0.65 },
    },
  },
} as const;

export const COACH_CONFIG = {
  minInterval: 3,     // s between two lines
  wheelieTime: 0.2,   // s of front wheel up
  footMinSpeed: 1.5,  // m/s; below this the bike is stopped, not turning
  footLean: 0.35,     // rad of lean that makes a slow turn worth the foot
  footTime: 0.8,      // s of a slow leaned turn without the foot
  airNoseHigh: 0.35,  // rad nose up in the air
  airNoseLow: 0.45,   // rad nose down in the air
  airTime: 0.25,      // s held before the line
  slopePitch: 0.2,    // rad of bike pitch that counts as a climb / descent
  slopeTime: 0.6,     // s held
  sandTime: 0.5,      // s of shut throttle in sand
  hardFrontBrake: 0.6, // fraction of the front brake torque that is a grab
  brakeLean: 0.35,    // rad of lean where a hard front brake is too much
  hitSpeed: 2,        // m/s into an obstacle worth a line
    warnLean: 0.95,     // rad of lean (55 deg) past which the coach warns: too much lean
    warnSlide: 0.7,     // rad of sideslip (40 deg) past which the coach warns: too much throttle / bike unstable
} as const;

export const PROGRESSION_CONFIG = {
  trackMinStars: 1,     // per drill, all three drills
  enduroLapTime: 95,    // s; one main-track lap under this unlocks enduro
  timeTrialLaps: 3,     // or finishing a time trial of this many laps
} as const;
